import { omit } from 'lodash';
import { RedirectionStateObject } from '../types';
import { tanstackUrlSearch, uriSafe } from '../utils';
import { featureFlagStateService } from 'ui/state/feature-flag.state.service';

export const alertsRedirections: RedirectionStateObject = {
  'dashboard.triggers.alert-definitions': params => {
    const normalizedParams = {
      ...omit(params, 'search'),
      searchTerm: params.search,
    };
    const search = tanstackUrlSearch(normalizedParams);

    return `/360/alerts/configurations${search}`;
  },
  'dashboard.event-management': params => {
    // The classic page has no URL params, so the Open 360 page starts unfiltered.
    if (featureFlagStateService.isFeatureEnabled('LogsEventManagementOpen360')) return '/360/alerts/event-management';

    const search = tanstackUrlSearch(params);

    return `/360/alerts/triggered${search}`;
  },
  'dashboard.alerts-v2019-new': () => `/360/alerts/new`,
  'dashboard.alerts-v2019-edit': params => {
    return `/360/alerts/${uriSafe(params.id)}`;
  },
  'view-investigate-alert': ({ triggeredId, switchToAccountId }) => {
    if (!triggeredId) return '/360/alerts/triggered';

    const searchParams = {
      triggeredId,
      ...(switchToAccountId && { switchToAccountId }),
    };

    return `/360/view-investigate-alert${tanstackUrlSearch(searchParams)}`;
  },
  'view-triggered-alert': ({ definitionId, from, to, switchToAccountId }) => {
    if (!definitionId || !from || !to) return '/360/alerts/triggered';

    const searchParams = {
      definitionId,
      from,
      to,
      ...(switchToAccountId && { switchToAccountId }),
    };

    return `/360/view-triggered-alert${tanstackUrlSearch(searchParams)}`;
  },
};
